/** @jsxImportSource solid-js */
import { createSignal, type JSX } from "solid-js";
import { Icons } from "../icons.solid";
import { createTextInput } from "./text.solid";

export function createPasswordInput({
  label = "Password",
  placeholder = "Choose a strong password",
  tooltip = null as JSX.Element,
}) {
  const [shown, setShown] = createSignal(false);
  const swap = (e: Event) => {
    e.preventDefault();
    setShown(!shown());
    baseInput.setKind(shown() ? "text" : "password");
  };

  // TODO: implement haveibeenpwned integration
  // TODO: debounce that

  const baseInput = createTextInput({
    label,
    kind: "password",
    placeholder,
    icon: (
      <button
        type="button"
        onClick={swap}
        class="absolute inset-y-0 end-0 flex items-center z-20 px-3 cursor-pointer text-brand-500 rounded-e-md focus:outline-none focus:text-primary-900 border-0"
      >
        {shown() ? (
          <Icons.User.Auth.ShowPassword />
        ) : (
          <Icons.User.Auth.HidePassword />
        )}
      </button>
    ),
    tooltip: tooltip,
  });

  return {
    component: baseInput.component,
    value: baseInput.value,
  };
}
